import * as Sentry from 'utils/sentryLazy';
import { createLoggerWithSentry } from '../../logger';

import React, { Component, ErrorInfo, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import ErrorEventEmitter, { ERROR_EVENTS, ErrorEventData } from 'services/ErrorEventEmitter';
import translations from 'translations';
import messages from 'utils/messages';

interface ErrorBoundaryState extends ErrorEventData {}

export class ErrorBoundary extends Component<{ children?: ReactNode }, ErrorBoundaryState> {
  public state = { error: null, errorInfo: null };

  private errorBoundaryLogger = createLoggerWithSentry({
    defaultScope: {
      component: 'ErrorBoundary',
      source: 'react-error-boundary',
    },
    enableBreadcrumbs: true,
    enableTracing: true,
  });

  public componentDidCatch(error: Error | null, errorInfo: ErrorInfo | null) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });

    if (process.env.APP_ENV !== 'production') {
      ErrorEventEmitter.emit(ERROR_EVENTS.ERROR_OCCURRED, { error: error, errorInfo: errorInfo });
    }

    this.errorBoundaryLogger.error(error, {
      errorInfo: errorInfo?.componentStack,
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    });
  }

  public render() {
    const { error, errorInfo } = this.state;
    const lang = window.localStorage.getItem('lang') || 'vi';
    if (error || errorInfo) {
      return (
        <div>
          <h2>
            <FormattedMessage {...messages.sentryError} />
          </h2>
          <a
            onClick={() =>
              Sentry.showReportDialog({
                lang: lang,
                title: translations(messages.sentryTitle),
                subtitle: translations(messages.sentrySubtitle),
                subtitle2: translations(messages.sentrySubtitle2),
                labelName: translations(messages.sentryLabelName),
                labelEmail: translations(messages.sentryLabelEmail),
                labelComments: translations(messages.sentryLabelComments),
                labelClose: translations(messages.sentryLabelClose),
                labelSubmit: translations(messages.sentryLabelSubmit),
                errorGeneric: translations(messages.sentryErrorGeneric),
                errorFormEntry: translations(messages.sentryErrorFormEntry),
                successMessage: translations(messages.sentrySuccessMessage),
              })
            }
          >
            <FormattedMessage {...messages.sentryReportFeedback} />
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}
